<article class="w-full relative" style="height: 100dvh;">
  <app-navbar [showLogo]="false"></app-navbar>

  <app-transport-map></app-transport-map>
</article>